import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import SubNav from '../components/subNav';
import SEO from '../components/SEO';
import { baseUrl } from '../config';



const JobApplications = ({addNotification}) => {
  const location = useLocation();

  // Default job data...
  const defaultJob = { jobTitle: 'Software Engineer', jobId: 1 };
  const { jobTitle = defaultJob.jobTitle, jobId = defaultJob.jobId } = location.state || defaultJob;

  // Sample applicants data...
  const initialApplicants = [
    { id: 1, jobId: 1, name: 'John Doe', email: 'john@example.com', resume: 'Resume.pdf', status: 'Pending' },
    { id: 2, jobId: 1, name: 'Jane Smith', email: 'jane@example.com', resume: 'Resume.pdf', status: 'Pending' },
    { id: 3, jobId: 2, name: 'Michael Brown', email: 'michael@example.com', resume: 'Resume.pdf', status: 'Pending' },
  ];

  const [applicants, setApplicants] = useState(initialApplicants);
  const [selectedApplicant, setSelectedApplicant] = useState(null);
  const [actionType, setActionType] = useState('');
  const [showModal, setShowModal] = useState(false);

  const jobApplicants = applicants.filter(applicant => applicant.jobId === jobId);

  const openModal = (applicant, action) => {
    setSelectedApplicant(applicant);
    setActionType(action);
    setShowModal(true);
  };

  const handleSend = () => {
    const updatedApplicants = applicants.map(applicant =>
      applicant.id === selectedApplicant.id
        ? { ...applicant, status: actionType === 'Approve' ? 'Approved' : 'Declined' }
        : applicant
    )

    setApplicants(updatedApplicants);
    setShowModal(false);

    // Add notification message
    const notificationMessage = `${selectedApplicant.name}'s application has been ${actionType.toLowerCase()}.`;
    addNotification(notificationMessage);
  };

  const handleCancel = () => setShowModal(false);

  return (
    <>
    <SEO
      title="Job Applications"
      description="Review and manage job applications for your film production roles on ProducerBuddy."
      url="https://producerbuddy.pilomation.com/job-applications"
      robots="noindex, nofollow"
    />
    <div className="bg-gray-800 p-4 rounded-lg shadow-md">
      <h2 className="text-3xl font-bold mb-6">{jobTitle} - Applications</h2>

      <table className="min-w-full bg-gray-800 rounded shadow-md">
        <thead>
          <tr className="bg-gray-700">
            <th className="py-2 px-4 text-left text-white">Name</th>
            <th className="py-2 px-4 text-left text-white">Email</th>
            <th className="py-2 px-4 text-left text-white">Resume</th>
            <th className="py-2 px-4 text-left text-white">Actions</th>
            <th className="py-2 px-4 text-left text-white">Status</th>
          </tr>
        </thead>
        <tbody>
          {jobApplicants.map((applicant) => (
            <tr key={applicant.id} className="border-b border-gray-700">
              <td className="py-2 px-4 text-white">{applicant.name}</td>
              <td className="py-2 px-4 text-white">{applicant.email}</td>
              <td className="py-2 px-4">
                <a href={`/uploads/${applicant.resume}`} download className="text-yellow-400">Download</a>
              </td>
              <td className="py-2 px-4">
                {applicant.status === 'Pending' ? (
                  <>
                    <button
                      onClick={() => openModal(applicant, 'Approve')}
                      className="bg-green-600 text-white px-2 py-1 rounded mr-2"
                    >
                      Approve
                    </button>
                    <button
                      onClick={() => openModal(applicant, 'Decline')}
                      className="bg-red-600 text-white px-2 py-1 rounded"
                    >
                      Decline
                    </button>
                  </>
                ) : (
                  <span className="text-gray-400">{applicant.status}</span>
                )}
              </td>
              <td className="py-2 px-4 text-white">
                {/* Display status message based on approval or decline */}
                {applicant.status === 'Approved' && <span className="text-green-500">Approved</span>}
                {applicant.status === 'Declined' && <span className="text-red-500">Declined</span>}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
      <Link to="/jobpostings" className="mt-4 inline-block text-yellow-400">Back to Job Postings</Link>

      {/* Modal */}
      {showModal && (
        <div className=" inset-0 bg-gray-800 bg-opacity-75 flex justify-center items-center">
          <div className="bg-white p-6 rounded shadow-lg w-1/3">
            <h3 className="text-xl font-semibold mb-4">{actionType} Application</h3>
            <p className="mb-6">
              {actionType === 'Approve'
                ? `Congratulations! You have moved ${selectedApplicant.name} to the next step.`
                : `We are sorry, we had to move with other candidates's application.`}
            </p>
            <div className="flex justify-end">
              <button
                onClick={handleSend}
                className="bg-blue-600 text-white px-4 py-2 rounded mr-2"
              >
                Send
              </button>
              <button
                onClick={handleCancel}
                className="bg-gray-500 text-white px-4 py-2 rounded"
              >
                Cancel
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
    </>
    
  );
};

export default JobApplications;

